import React from 'react'
import { Panel, Row, Col, Table, ButtonGroup } from 'rsuite'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadLitigationFileByPath, getLitigationFile } from '../../redux/actions/legal'
import TooltipButton from '../../components/buttons/TooltipButton'

export default function LitigationView(props) {
  const { Column, HeaderCell, Cell } = Table
  const { schema } = props

  const Styles = {
    headerStyle: {
      textAlign: 'right',
      fontWeight: 550,
    },
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await downloadLitigationFileByPath(fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await downloadLitigationFileByPath(fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const LawInfo = ({ schema, lg = 12, md = 12, sm = 24, xs = 24, subLabel = 9, subValue = 15 }) => {
    return (
      <Col lg={lg} md={md} sm={sm} xs={xs} style={{ marginTop: 10 }}>
        <Row>
          <Col
            lg={subLabel}
            md={subLabel}
            sm={subLabel}
            xs={subLabel}
            style={{ ...Styles.headerStyle }}
          >
            <label>{schema.label}</label>
          </Col>

          <Col lg={subValue} md={subValue} sm={subValue} xs={subValue}>
            <label>{schema.value || '-'}</label>
          </Col>
        </Row>
      </Col>
    )
  }

  const LawInfoHTML = ({ schema }) => {
    return (
      <Panel
        collapsible
        defaultExpanded
        bordered
        header={<label style={{ fontWeight: 550, color: '#575757' }}>{schema.label}</label>}
        style={{ marginTop: 10, marginBottom: 20 }}
      >
        <div
          style={{
            marginLeft: 20,
          }}
          dangerouslySetInnerHTML={{ __html: schema.value || '-' }}
        />
      </Panel>
    )
  }

  return (
    <>
      <Panel
        collapsible
        defaultExpanded
        bordered
        header={schema?.header || 'ข้อมูลคดี'}
        style={{ marginBottom: 20 }}
      >
        <Row>
          {schema.litigationName && (
            <LawInfo schema={schema.litigationName} lg={14} md={14} sm={24} xs={24} />
          )}
          {schema.lawType && (
            <LawInfo
              schema={schema.lawType}
              lg={10}
              md={10}
              sm={24}
              xs={24}
              subLabel={12}
              subValue={12}
            />
          )}
        </Row>
        <Row>
          {schema.projectInfo && (
            <LawInfo schema={schema.projectInfo} lg={14} md={14} sm={24} xs={24} />
          )}
          {schema.docNumberOfPurchase && (
            <LawInfo
              schema={schema.docNumberOfPurchase}
              lg={10}
              md={10}
              sm={24}
              xs={24}
              subLabel={12}
              subValue={12}
            />
          )}
        </Row>
        <Row>
          {schema.referCodeDocument && (
            <LawInfo schema={schema.referCodeDocument} lg={14} md={14} sm={24} xs={24} />
          )}
          {schema.referDateDocument && (
            <LawInfo
              schema={schema.referDateDocument}
              lg={10}
              md={10}
              sm={24}
              xs={24}
              subLabel={12}
              subValue={12}
            />
          )}
        </Row>
        <Row>
          {schema.offender && <LawInfo schema={schema.offender} lg={14} md={14} sm={24} xs={24} />}
          {/* {schema.limitation && (
            <LawInfo
              schema={schema.limitation}
              lg={10}
              md={10}
              sm={24}
              xs={24}
              subLabel={12}
              subValue={12}
            />
          )} */}
        </Row>
        <Row>
          {schema.limitation && (
            <LawInfo schema={schema.limitation} lg={14} md={14} sm={24} xs={24} />
          )}
          {schema.currentStatuteLimitations && (
            <LawInfo
              schema={schema.currentStatuteLimitations}
              lg={10}
              md={10}
              sm={24}
              xs={24}
              subLabel={12}
              subValue={12}
            />
          )}
        </Row>
        <Row>
          {schema.lawStatus && (
            <LawInfo schema={schema.lawStatus} lg={14} md={14} sm={24} xs={24} />
          )}
          {schema.lawSubStatus && (
            <LawInfo
              schema={schema.lawSubStatus}
              lg={10}
              md={10}
              sm={24}
              xs={24}
              subLabel={12}
              subValue={12}
            />
          )}
        </Row>
        <Row>
          {schema.capital && <LawInfo schema={schema.capital} lg={14} md={14} sm={24} xs={24} />}
          {schema.damages && (
            <LawInfo
              schema={schema.damages}
              lg={10}
              md={10}
              sm={24}
              xs={24}
              subLabel={12}
              subValue={12}
            />
          )}
        </Row>
        {schema.causeOfWrongdoing && <LawInfoHTML schema={schema.causeOfWrongdoing} />}
        {schema.detail && <LawInfoHTML schema={schema.detail} />}
        {schema.files && schema.files.length > 0 && (
          <Table autoHeight wordWrap bordered data={schema.files}>
            <Column width={90} align="center" fixed>
              <HeaderCell>ไฟล์ที่</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column minWidth={300} width={300} flexGrow={1}>
              <HeaderCell>ชื่อไฟล์</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return rowData.label
                }}
              </Cell>
            </Column>

            <Column width={100} align="center">
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return (
                    <>
                      {rowData.path && (
                        <ButtonGroup>
                          <TooltipButton
                            isStart={true}
                            icon="eye"
                            tooltip={`แสดง`}
                            onClick={(e) => onPreview(rowData)}
                          ></TooltipButton>
                          <TooltipButton
                            isStart={false}
                            icon="download"
                            tooltip={`ดาวน์โหลด`}
                            onClick={(e) => onDownload(rowData)}
                          ></TooltipButton>
                        </ButtonGroup>
                      )}
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        )}
      </Panel>
    </>
  )
}
